import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteBudgetAllocation } from 'modules/finance/hooks/useBudgetAllocations'

interface DeleteEmployeeModalProps {
  closeModal: () => void
  budgetId: string
  allocationIds: string[]
  periodStart: string
  refetchBudget: (param: { id: string; periodStart: string }) => void
}

const DeleteEmployeeModal = ({
  closeModal,
  budgetId,
  allocationIds,
  periodStart,
  refetchBudget,
}: DeleteEmployeeModalProps) => {
  const { deleteBudgetAllocation } = useDeleteBudgetAllocation({
    budgetId: budgetId,
  })

  const handleSubmit = async () => {
    if (allocationIds.length === 0) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('budgets.detail.delete_employee_modal.no_selected_employees_error'),
      })
      return
    }
    const response = await deleteBudgetAllocation({
      ids: allocationIds,
      budgetId: budgetId,
    })

    const result = handleResult(response, (_) => undefined)

    if (result.success) {
      refetchBudget({
        id: budgetId,
        periodStart,
      })
      app.setFlash({
        type: 'correct',
        message: i18n.t('budgets.detail.delete_employee_modal.submit_success'),
      })

      closeModal()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('budgets.detail.delete_employee_modal.submit_error'),
      })
    }
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t('budgets.detail.delete_employee_modal.title')}
      description={i18n.t('budgets.detail.delete_employee_modal.description')}
      onSubmit={handleSubmit}
      onClose={closeModal}
      footer={
        <>
          <Button type="secondary" onClick={closeModal}>
            {i18n.t('common.close')}
          </Button>
          <Button submit>{i18n.t('common.remove')}</Button>
        </>
      }
    />
  )
}

export default DeleteEmployeeModal
